import { useState } from "react";
import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "react-bootstrap";
import { connect } from "react-redux";

import { getContribuyentes } from "../../../redux/Sections/Contribuyentes/actions";
import { Tabla } from "../../../components/Table/Table";
import { RowData } from "./Components/RowData/RowData";

import { faEye } from "@fortawesome/free-regular-svg-icons";
import icon from "../../../assets/static/images/secciones/contribuyentes.png";
import { v4 as uuidv4 } from "uuid";
import { ContribuyentesFilter } from "./Components/ContribuyentesFilter/ContribuyentesFilter";
import ShowContribuyente from "../../../components/ContribuyentesModal/ShowContribuyente";
import { setLoading } from "../../../redux/Loading/actions";
import DescargarExcel from "../../../components/DescargarExcel/DescargarExcel";
import TooltipText from "../../../components/TooltipText";
import AlertInfo from "../../../components/AlertInfo";
import "./Contribuyentes.css";

const Contribuyentes = ({ dataList }) => {
  const [showFilter, setShowFilter] = useState(true);
  const [show, setShow] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [contribuyente, setContribuyente] = useState();


  const handleOpen = (row) => {
    setContribuyente(row);
    setShow(true);
  };
  const handleClose = () => setShow(false);


  // ---------------------------------------------------------------------------

  const columns = [
    {
      title: "NOMBRE",
      dataIndex: "APYNOM",
      key: "APYNOM",
    },
    {
      title: "DNI",
      dataIndex: "NRO_DOC",
      key: "NRO_DOC",
    },
    {
      title: "DOMICILIO",
      dataIndex: "domicilio",
      key: "domicilio",
    },
    {
      title: "ACCIONES",
      dataIndex: "accion",
      render: (a, row) => (<TooltipText placement="right" text="Mostrar datos del contribuyente" >
        <FontAwesomeIcon style={{ cursor: "pointer" }} title="Contribuyente" onClick={() => handleOpen(row)} icon={faEye} size="lg" />
      </TooltipText>
      )
    },
  ];

  const formatData = (dataTable) => {
    try {
      if (dataTable && dataTable?.length) {

        return dataTable.map((e) => {
          return {
            uuid: uuidv4(),
            ...e,
            domicilio: `${e.CALLE} ${e.NRO}`
          };
        });
      } else {
        return [];
      }
    }
    catch (err) {
      console.log(err);
      return [];
    }
  };

  function exportData(list) {
    let filename = "contribuyentes.xlsx";

    const dataList = list.map((e) => {
      return {
        "APELLIDO Y NOMBRE": e.APYNOM,
        "DNI": e.NRO_DOC,
        "DIRECCIÓN": `${e.CALLE} ${e.NRO}`,
      };
    });

    let name = "Contribuyentes";

    return {
      dataList,
      filename,
      name
    };
  }

  return (
    <div className="section-container section-content">
      <div className="section-title d-flex align-items-center">
        <img src={icon} alt="contribuyente" className="opacity-icon" />
        <span>Contribuyentes</span>
      </div>

      <div className="buttons-filter">
        <h3 className="mr-3">Filtros:</h3>
        <div className="button-filter">
          {showFilter ?
            <Button
              variant="danger"
              onClick={() => setShowFilter(false)}
              className="danger-button d-flex align-items-center"
              style={{ maxWidth: 105 }}
            >
              <FontAwesomeIcon icon={faArrowDown} size="1x" /><span className="ml-2">Ocultar</span>
            </Button>
            : <Button
              onClick={() => setShowFilter(true)}
              className="custom-button d-flex align-items-center"
              style={{ maxWidth: 105 }}
            ><FontAwesomeIcon icon={faArrowUp} size="1x" /><span className="ml-2">Mostrar</span>
            </Button>}
        </div>
      </div>
      <div className="section-filter">
        <ContribuyentesFilter
          showFilter={showFilter}
          setShowFilter={setShowFilter}
          style={{ marginBottom: "30px" }}
          action={getContribuyentes}
          setShowTable={setShowTable}
          section="contribuyentes"
        />
      </div>
      {showTable ? (
        <div className="section-table">
          {dataList?.length ? (
            <AlertInfo>
              <div className="d-flex align-items-center">
                Haga click en
                <div className="d-flex mx-1">
                  <button type="button" className="ant-table-row-expand-icon ant-table-row-expand-icon-collapsed" aria-label="Expand row"></button>
                </div>
                para ver la lista de inmuebles del contribuyente.
              </div>
            </AlertInfo>
          ) : null}
          <Tabla
            dataList={formatData(dataList)}
            columns={columns}
            expandable={true}
            selection={false}
            RowData={RowData}
          />
          <div className="mt-3">
            <div style={{ maxWidth: 170 }}>
              <DescargarExcel data={exportData(dataList)} />
            </div>
          </div>
        </div>
      ) : null}
      {show ? <ShowContribuyente show={show} handleClose={handleClose} contribuyente={contribuyente} /> : null}
    </div>
  );
};

const mapStateToProps = (state) => {
  return ({
    dataList: state.dashboard.contList
  });
};

const mapDispatchToProps = (dispatch) => {
  return {
    getData: (data) => dispatch(getContribuyentes(data)),
    setLoading: (value) => dispatch(setLoading(value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Contribuyentes);